import React from 'react';
import { Header } from '../../../shared/components/Header';
import { CustodySolutionsFooter } from './CustodySolutionsFooter';

const Demise: React.FC = () => {
  const handleRedirect = () => {
    const domain = window.location.hostname;
    
    let redirectUrl = 'https://custodysolutions.gs.com/client-app/'; // Default to prod
    
    if (domain.includes('dev.')) {
      redirectUrl = 'https://dev.custodysolutions.site.gs.com/client-app/';
    } else if (domain.includes('qa.') || domain.includes('localhost') || domain.includes('127.0.0.1')) {
      redirectUrl = 'https://qa.custodysolutions.site.gs.com/client-app/';
    } else if (domain.includes('uat.custodysolutions')) {
      redirectUrl = 'https://uat.custodysolutions.gs.com/client-app/';
    }
    
    window.open(redirectUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <div className="bg-white">
        <Header />
      </div>

      {/* Main Content */}
      <div className="flex-grow flex flex-col justify-center py-16 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
          <div className="bg-white px-8 py-12">
            <div>
              <div className="p-6 mb-8 text-left">
                <p className="text-gray-800 text-lg leading-relaxed">
                  Our new Goldman Sachs Custody Solutions website is now available, replacing the previous website. Please{' '}
                  <button
                    onClick={handleRedirect}
                    className="inline-flex items-center text-blue-700 hover:text-blue-900 font-medium underline transition-colors duration-200"
                  >
                    click here
                  </button>
                  {' '}and use your existing credentials to access the new website.
                </p>
                <p className="text-gray-800 text-lg leading-relaxed mt-6">
                  For any questions, please contact Client Services at (844) 413-1820.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <CustodySolutionsFooter />
    </div>
  );
};

export default Demise;
